module.exports = __webpack_public_path__ + "static/media/notification.a77ded4b.svg";